import {StagingTitelineAppRigMoves} from "../types/StagingTitelineAppRigMoves";
import {RigMovesData} from "../types/RigMovesData";
import { getApiUrl } from '../config/api';

export const fetchRigMoveByPid = async (pid: number, aid: number = -1): Promise<RigMovesData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineRigMoves/GetRigMoveByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No rig move found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching rig move for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppRigMoves[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((rigMove) => rigMove.DataSource === aid.toString());
        }

        return backendData.map((rigMove) => ({
            key: rigMove.RmId,
            rm_id: rigMove.RmId,
            pid: rigMove.Pid,
            hole_id: rigMove.HoleID,
            move_type: rigMove.MoveType,
        }));

    } catch (error) {
        console.error("Error in fetchRigMoveByPid API call:", error);
        return [];
    }
};

export const addRigMoveRow = async (rigMoveRow: RigMovesData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineRigMoves/AddRigMove');

    const cloudPayload = [
        {
            Pid: rigMoveRow.pid ?? -1,
            HoleID: rigMoveRow.hole_id,
            MoveType: rigMoveRow.move_type,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Rig move row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add rig move row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addRigMoveRow API call:", error);
        return false;
    }
};

export const updateRigMoveRow = async (rm_id: number, updatedRow: RigMovesData) => {
    const apiUrl = getApiUrl(`/api/TitelineRigMoves/UpdateRigMoveByRmid/${rm_id}`);
    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        MoveType: updatedRow.move_type,
    };

    console.log("cloudPayload:", cloudPayload);

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Rig move row with RmId ${rm_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update rig move row with RmId ${rm_id}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateRigMoveRow API call:", error);
        return false;
    }
};

export const deleteRigMoveByRmId = async (rm_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineRigMoves/DeleteRigMoveByRmid/${rm_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteRigMoveByRmId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete rig move row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteRigMoveByRmId API call:", error);
        return false;
    }
};
